__turbopack_context__.v({
  "changeAddressLink": "checkout-module-scss-module__rJTBMq__changeAddressLink",
  "checkboxes": "checkout-module-scss-module__rJTBMq__checkboxes",
  "checkout": "checkout-module-scss-module__rJTBMq__checkout",
  "checkoutDetails": "checkout-module-scss-module__rJTBMq__checkoutDetails",
  "checkoutPayment": "checkout-module-scss-module__rJTBMq__checkoutPayment",
  "checkoutSidebar": "checkout-module-scss-module__rJTBMq__checkoutSidebar",
  "column": "checkout-module-scss-module__rJTBMq__column",
  "columns": "checkout-module-scss-module__rJTBMq__columns",
  "container": "checkout-module-scss-module__rJTBMq__container",
  "control": "checkout-module-scss-module__rJTBMq__control",
  "hint": "checkout-module-scss-module__rJTBMq__hint",
  "loading": "checkout-module-scss-module__rJTBMq__loading",
  "lockedShippingAddress": "checkout-module-scss-module__rJTBMq__lockedShippingAddress",
  "missingShippingAddress": "checkout-module-scss-module__rJTBMq__missingShippingAddress",
  "orderNotes": "checkout-module-scss-module__rJTBMq__orderNotes",
  "radioOptions": "checkout-module-scss-module__rJTBMq__radioOptions",
  "selectWrapper": "checkout-module-scss-module__rJTBMq__selectWrapper",
  "shippingAddressHeader": "checkout-module-scss-module__rJTBMq__shippingAddressHeader",
  "shippingMethodsContent": "checkout-module-scss-module__rJTBMq__shippingMethodsContent",
  "shippingMethodsInitialLoader": "checkout-module-scss-module__rJTBMq__shippingMethodsInitialLoader",
  "shippingMethodsLoader": "checkout-module-scss-module__rJTBMq__shippingMethodsLoader",
  "table": "checkout-module-scss-module__rJTBMq__table",
  "timeError": "checkout-module-scss-module__rJTBMq__timeError",
  "wrapper": "checkout-module-scss-module__rJTBMq__wrapper",
});
